<template>
  <v-navigation-drawer
    v-model="drawer"
    class="profile-drawer"
    right
    temporary
    disable-resize-watcher
    width="300px"
    fixed
  >
    <perfect-scrollbar :options="{ suppressScrollX: true }">
      <div class="profile-drawer__content px-4 py-2">
        <profile-drawer-user class="mb-4" />

        <div class="profile-drawer__divider mb-4"></div>

        <balance-card v-if="canUseBilling" class="mb-3" />

        <div class="profile-drawer__section mb-3">
          <profile-drawer-menu :billing-locked="!canUseBilling" />
        </div>

        <div class="profile-drawer__section profile-drawer__section_hoverable mb-3">
          <knowledge-base-card />
        </div>

        <div class="profile-drawer__section profile-drawer__section_hoverable mb-3">
          <marketplace-card />
        </div>

        <!-- У карточки поддержки свой тёмный фон: без серой секции-обёртки.
             ВРЕМЕННО: поддержка только в филиалах из VUE_APP_SUPPORT_BRANCH_IDS (support/enabled) -->
        <tech-support-card v-if="supportEnabled" class="mb-3" />

        <last-news class="mt-auto mb-3" />

        <div class="profile-drawer-legal-info__wrapper mb-3">
          <div class="profile-drawer-legal-info__title mb-1">
            Юридическая информация
          </div>
          <a
            class="profile-drawer-legal-info__link mb-1"
            href="https://fakt-crm.com/offer-agreement"
            target="_blank"
          >
            Договор оферты
          </a>
          <a
            class="profile-drawer-legal-info__link mb-1"
            href="https://fakt-crm.com/privacy-policy"
            target="_blank"
          >
            Политика конфиденциальности
          </a>
          <a
            class="profile-drawer-legal-info__link"
            href="https://fakt-crm.com/support-reglament"
            target="_blank"
          >
            Регламент тех. поддержки
          </a>
        </div>
      </div>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import BalanceCard from '@/components/profile-drawer/BalanceCard.vue'
  import ProfileDrawerMenu from '@/components/profile-drawer/ProfileDrawerMenu.vue'
  import LastNews from '@/components/profile-drawer/LastNews.vue'
  import ProfileDrawerUser from '@/components/profile-drawer/ProfileDrawerUser.vue'
  import KnowledgeBaseCard from '@/components/profile-drawer/KnowledgeBaseCard.vue'
  import MarketplaceCard from '@/components/profile-drawer/MarketplaceCard.vue'
  import TechSupportCard from '@/components/profile-drawer/TechSupportCard.vue'

  export default {
    name: 'ProfileDrawer',
    components: {
      TechSupportCard,
      ProfileDrawerUser,
      LastNews,
      ProfileDrawerMenu,
      BalanceCard,
      KnowledgeBaseCard,
      MarketplaceCard,
    },
    computed: {
      ...mapState({
        showProfileDrawer: (state) => state.app.showProfileDrawer,
      }),
      ...mapGetters({ supportEnabled: 'support/enabled' }),
      drawer: {
        get () {
          return this.showProfileDrawer
        },
        set (value) {
          value
            ? this.$store.commit('app/showProfileDrawer')
            : this.$store.commit('app/hideProfileDrawer')
        },
      },
    },
  }
</script>

<style scoped lang="less">
::v-deep {
  .profile-drawer.theme--dark.v-navigation-drawer {
    background-color: #fff;
  }

  // Шторка fixed — её высота равна окну, а не странице (у absolute она тянулась
  // на всю высоту документа и под контентом висел пустой хвост). Скроллер и
  // контейнер Vuetify тянем на всю шторку, иначе perfect-scrollbar не скроллит.
  .profile-drawer .v-navigation-drawer__content,
  .ps {
    height: 100%;
  }
}

.profile-drawer {
  // Контента бывает меньше высоты шторки (нет дайджеста, часть меню скрыта правами) —
  // тогда mt-auto прижимает юридический блок к низу.
  &__content {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  &__divider {
    width: 100%;
    height: 2px !important;
    background-color: #dbdfe6;
  }

  &__section {
    border: 2px solid #dbdfe6;
    border-radius: 5px;
    background-color: #f1f3f6;
    padding: 8px 10px;

    &_hoverable {
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #e0e4ea;
      }
    }
  }

  &-legal-info {
    &__wrapper {
      color: #999;
    }

    &__title {
      font-size: 12px;
    }

    &__link {
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      color: #999;
      transition: color 0.2s ease;

      &:hover {
        color: #000;
      }
    }
  }
}
</style>
